import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useSuggestKeyboard } from './useSuggestKeyboard';
import { clamp } from '../../../internal/utils';
export function useSuggestSelectedItem(_ref, _ref2) {
  var suggestions = _ref.suggestions,
    open = _ref.open,
    onClose = _ref.onClose,
    onSelect = _ref.onSelect;
  var suggestionsChildrenRef = _ref2.suggestionsChildrenRef,
    listBoxRef = _ref2.listBoxRef;
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedItemIndex = _React$useState2[0],
    setSelectedItemIndex = _React$useState2[1];
  React.useEffect(function () {
    return setSelectedItemIndex(0);
  }, [open]);
  var onEscape = React.useCallback(function () {
    return open && (onClose === null || onClose === void 0 ? void 0 : onClose({
      source: 'escapeKey'
    }));
  }, [onClose, open]);
  var onEnter = React.useCallback(function () {
    return selectedItemIndex !== undefined && suggestions[selectedItemIndex] && open && (onSelect === null || onSelect === void 0 ? void 0 : onSelect(suggestions[selectedItemIndex], {
      source: 'keyboard'
    }));
  }, [onSelect, suggestions, selectedItemIndex, open]);
  var onKeyboardSetItem = React.useCallback(function (actionType) {
    setSelectedItemIndex(function (previousIndex) {
      var _suggestions$nextInde, _listBoxRef$current;
      var nextIndex = {
        last: suggestions.length - 1,
        first: 0,
        increment: clamp((previousIndex !== null && previousIndex !== void 0 ? previousIndex : 0) + 1, 0, suggestions.length - 1),
        decrement: clamp((previousIndex !== null && previousIndex !== void 0 ? previousIndex : 0) - 1, 0, suggestions.length - 1)
      }[actionType];
      if (((_suggestions$nextInde = suggestions[nextIndex]) === null || _suggestions$nextInde === void 0 ? void 0 : _suggestions$nextInde.type) === 'title') {
        return previousIndex;
      }
      (_listBoxRef$current = listBoxRef.current) === null || _listBoxRef$current === void 0 || (_listBoxRef$current = _listBoxRef$current.children[nextIndex]) === null || _listBoxRef$current === void 0 || _listBoxRef$current.scrollIntoView({
        block: 'nearest'
      });
      return nextIndex;
    });
  }, [listBoxRef, suggestions]);
  useSuggestKeyboard({
    onEnter: onEnter,
    onEscape: onEscape,
    onKeyboardSetItem: onKeyboardSetItem,
    suggestionsChildrenRef: suggestionsChildrenRef,
    listBoxRef: listBoxRef
  });
  return {
    suggestionsChildrenRef: suggestionsChildrenRef,
    setSelectedItemIndex: setSelectedItemIndex,
    selectedItemIndex: selectedItemIndex
  };
}